import { render } from "./Dividas.vue?vue&type=template&id=0a43dc72&scoped=true"
import script from "./Dividas.vue?vue&type=script&lang=js"
export * from "./Dividas.vue?vue&type=script&lang=js"

import "./Dividas.vue?vue&type=style&index=0&id=0a43dc72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a43dc72"]])

export default __exports__